import React, { Component } from 'react'

import Grid from '../../../../shared/elements/grid'
import Panel from '../../../../shared/elements/panel'
import Text from '../../../../shared/elements/text'
import Divider from '../../../../shared/elements/divider'
import RemoveButton from '../../../../shared/elements/removeButton'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Check from '../../../../shared/elements/check'
import Icon from '../../../../shared/elements/icon'
import { QualityCheckIcons } from '../../../../shared/elements/icons'

// Utils
import { translation, enumtranslate } from '../../../../utils/helpers'

class QualityCheckSettingsBox extends Component {
  constructor (props) {
    super(props)
    this.state = {
      customName: props.group !== null ? props.group.CustomName : ''
    }
    this.renderTask = this.renderTask.bind(this)
  }

  renderTask (task, key) {
    const { quality } = this.props

    const onChange = (e) => {
      console.log('QualityCheckSettingsBox\' onChange event triggered!', e)
      e.persist()
      let tasks = [...quality.QualityCheckTasks]
      tasks = tasks.map((v) => {
        if (v.QualityCheckTaskId === task.QualityCheckTaskId) {
          if (e.target.value === 'start') {
            v.PerformAtStart = e.target.checked
          } else {
            v.PerformAtEnd = e.target.checked
          }
        }
        return v
      })

      if (this.props.onChange !== null) {
        this.props.onChange(tasks)
      }
    }

    let icon = ''
    switch (task.StepNr) {
      case 1:
        icon = QualityCheckIcons.Quality_Check_New
        break
      case 2:
        icon = QualityCheckIcons.Quality_Check_Pretreatment
        break
      case 3:
        icon = QualityCheckIcons.Quality_Check_Filler
        break
      case 4:
        icon = QualityCheckIcons.Quality_Check_Sanding
        break
      case 5:
        icon = QualityCheckIcons.Quality_Check_Coating
        break
      case 6:
        icon = QualityCheckIcons.Quality_Check_Preparing
        break
      case 7:
        icon = QualityCheckIcons.Quality_Check_Handover
        break
      case 101:
        icon = QualityCheckIcons.Quality_Check_Disassembly
        break
      case 102:
        icon = QualityCheckIcons.Quality_Check_Repair
        break
      case 103:
        icon = QualityCheckIcons.Quality_Check_Assembly
        break
      case 104:
        icon = QualityCheckIcons.Quality_Check_Preparing_Body
        break
      case 105:
        icon = QualityCheckIcons.Quality_Check_Coating
        break
    }
    let ariaLabel = enumtranslate('PaintShopOrderSteps', task.StepNr)
    let disabledStart = task.ModifiedStart || !this.props.isLoaded
    let disabledEnd = task.ModifiedEnd || !this.props.isLoaded

    const headerItem = (
      <div
        className='hint--top'
        aria-label={translation(ariaLabel)}
        key={task.StepNr}
      >
        <Icon icon={icon} size='t' />
      </div>
    )
    const startItem = (
      <Check
        id={'Task_start_' + task.QualityCheckTaskId}
        name={'Task_start_' + task.QualityCheckTaskId}
        onChange={onChange}
        checked={task.PerformAtStart}
        disabled={disabledStart}
        value='start'
        key={task.StepNr}
        simple
      />
    )
    const endItem = (
      <Check
        id={'Task_end_' + task.QualityCheckTaskId}
        name={'Task_end_' + task.QualityCheckTaskId}
        onChange={onChange}
        checked={task.PerformAtEnd}
        disabled={disabledEnd}
        value='end'
        key={task.StepNr}
        simple
      />
    )

    return [
      headerItem,
      startItem,
      endItem
    ]
  }

  renderGroup (tasks, taskType) {
    const elementLists = tasks.reduce((lists, task) => {
      const taskLists = this.renderTask(task)

      lists.headerItems.push(taskLists[0])
      lists.startItems.push(taskLists[1])
      lists.endItems.push(taskLists[2])

      return lists
    }, {
      headerItems: [],
      startItems: [],
      endItems: []
    })

    let helpTextStart = ''
    let helpTextEnd = ''
    switch (taskType) {
      case 1:
        helpTextStart = '1935'
        helpTextEnd = '15167'
        break
      case 2:
        helpTextStart = '15161'
        helpTextEnd = '15162'
        break
      case 3:
        helpTextStart = '15163'
        helpTextEnd = '15164'
        break
      case 4:
        helpTextStart = '15165'
        helpTextEnd = '15166'
        break
    }

    return (
      <div>
        <Grid justify='center' align='center'>
          {elementLists.headerItems}
        </Grid>
        <LabelWrapper labelText={translation('271')} helpText={translation(helpTextStart)} simple>
          <Grid justify='center'>
            {elementLists.startItems}
          </Grid>
        </LabelWrapper>
        <LabelWrapper labelText={translation('2062')} helpText={translation(helpTextEnd)} simple>
          <Grid justify='center'>
            {elementLists.endItems}
          </Grid>
        </LabelWrapper>
      </div>
    )
  }

  render () {
    const { taskType, group, quality } = this.props
    if (quality === null) return null
    const qualityCheckTasks = quality.QualityCheckTasks

    let tasks = []
    for (var i = 0; i < qualityCheckTasks.length; i++) {
      let item = qualityCheckTasks[i]
      if (item.QualityCheckTaskType === taskType && (group === null || item.QualityCheckTaskGroupId === group.QualityCheckTaskGroupId)) {
        tasks.push(item)
      }
    }

    if (tasks.length === 0) return null

    let title = ''
    let helptext = ''
    switch (taskType) {
      case 1:
        title = '370' // layer thickness
        helptext = '15168'
        break
      case 2:
        title = '342' // qual. check
        helptext = '15169'
        break
      case 3:
        title = '2065'  // photo
        helptext = '1937'
        break
      case 4:
        title = '13396' // warranty code
        helptext = '1938'
        break
    }

    if (taskType === 5) {
      const onNameChange = (e) => {
        this.setState({ customName: e.target.value })
      }

      const onNameBlur = (e) => {
        group.CustomName = this.state.customName
        this.props.updateGroups(quality.QualityCheckTaskGroups)
      }

      const onDelete = () => {
        group.IsDeleted = true
        this.props.updateGroups(quality.QualityCheckTaskGroups)
      }

      return (
        // Custom task group
        <Panel title={group.CustomName} helpText={group.CustomName}>
          <Grid cols='auto 50px'>
            <Text value={this.state.customName} onChange={onNameChange} onBlur={onNameBlur} />
            <RemoveButton onClick={onDelete} />
          </Grid>
          <Divider noline />
          {this.renderGroup(tasks, taskType)}
        </Panel>
      )
    } else {
      // Regular tasks
      return (
        <Panel title={translation(title)} helpText={translation(helptext)}>
          {this.renderGroup(tasks, taskType)}
        </Panel>
      )
    }
  }
}

QualityCheckSettingsBox.defaultProps = {
  taskType: 1,
  group: null,
  // qualityCheckTasks: [],
  quality: null,
  onChange: null,
  isLoaded: false
}

export default QualityCheckSettingsBox



// WEBPACK FOOTER //
// ./src/app/pages/QualityCheckSettings/QualityCheckSettingsChild/QualityCheckSettingsBox/index.js